export default __webpack_public_path__ + "static/media/ais_default.7e9c148f.png";